import { Box, FormControlLabel, Switch } from "@mui/material";
import { useState } from "react";
import UpgradeDialogV2 from "../Dialogs/UpgradeDialogV2";

const formBuilderUpgradeDialog = {
  title: "Unlock Advanced Form Builder",
  subtitle: "Create custom forms, collect responses, and turn QR code scans into valuable leads.",
  features: [
    {
      primary: "Customizable Forms",
      secondary: "Design forms with text fields, checkboxes, dropdowns, and more to collect user input."
    },
    {
      primary: "QR Code-Linked Forms",
      secondary: "Easily link your forms to QR codes for seamless user interaction and data collection."
    },
    {
      primary: "Real-Time Response Tracking",
      secondary: "Monitor form submissions instantly and view detailed analytics on user engagement."
    },
    {
      primary: "Conditional Logic & Smart Fields",
      secondary: "Create interactive forms with dynamic fields that change based on user input."
    },
    {
      primary: "Lead Collection & CRM Integration",
      secondary: "Automatically send form submissions to your email, CRM, or marketing automation tools."
    },
    {
      primary: "Custom Branding & Styling",
      secondary: "Personalize form layouts with custom fonts, colors, and logos to match your brand."
    },
    {
      primary: "Export Data & API Access",
      secondary: "Download form responses as CSV files or integrate with third-party platforms via API."
    }
  ]
};

  
  
interface Props {
  show: boolean,
  hide:() => void
}

const FormTeaser = ({ show, hide }: Props) => {
    return(
        <>
            <UpgradeDialogV2 
                open={show} 
                onClose={hide} 
                title={formBuilderUpgradeDialog.title}
                subtitle={formBuilderUpgradeDialog.subtitle}
                requestedFeature="form"
            />

        </>
    )
}

export default FormTeaser;